
//type
import { carType } from "../../api/Cars/type/CarsType"

//mui
import StarIcon from '@mui/icons-material/Star';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import WeekendOutlinedIcon from '@mui/icons-material/WeekendOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';


//translate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";


interface bestCarsProps {
  element: carType
}

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const BestCar = ({element}:bestCarsProps) => {
  const {t} = useTranslation()
  return (
    <div className="rounded-[15px] border-[1px] border-solid border-darkColor overflow-hidden">
      <div className="h-[200px] w-full overflow-hidden">
          <img className='h-full w-full object-cover' src={`${storageURL}/${element.primary_images[0].url}`} alt="no_photo"/>
      </div>
      <div className="p-3 mt-3">
        <p className="font-[600]">{element.brand.name}</p>
        <div className="text-[#7F7F7F] text-sm">
          <div className="flex items-center gap-2 mt-2">
            <StarIcon  className="!text-[#FF8F3A]"/>
            <p>5.0</p>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <LocationOnOutlinedIcon/>
            <p>Damascus, SY</p>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <WeekendOutlinedIcon/>
            <p>{element.seating_capacity} {t("seats")}</p>
          </div>
          <div>
            {
              element.is_daily !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.daily_price))} / {t("day")}</p>
                </div>
              :
              element.is_weekly !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.weekly_price))} / {t("week")}</p>
                </div>
              :
              element.is_monthly !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.monthly_price))} / {t("month")}</p>
                </div>
              :
              <></>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default BestCar